import styled from 'styled-components';
import { device } from 'components/styles/MediaQuery';

export const ScCurrencyRemovalDeclined = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  letter-spacing: 0.01em;
  font-weight: 700;

  & > .title {
    color: ${({ theme }) => theme.whiteColor};
    font-size: 22px;
    line-height: 1.27;
  }

  & > .text {
    font-size: 16px;
    line-height: 1.75;
    color: ${({ theme }) => theme.grayColor1};
  }

  @media (${device.mobileS}) {
    & > .title {
      font-size: 18px;
      line-height: 1.33;
    }
  }
`;
